import styled from 'styled-components'

export const TitleGroup = styled.div`
  padding: ${props => (props.needsRightSpace ? '8px 16px' : '8px 12px 12px')};
  box-sizing: border-box;
  flex-grow: 1;
  h2,
  h3 {
    font-size: ${props => (props.isHorizontal ? '14px' : '12px')};
    font-weight: ${props => (props.isHorizontal ? '500' : 'normal')};
    margin: 0;
    line-height: ${props => !props.isHorizontal && '150%'};
  }

  h2 {
    font-weight: ${props => !props.isHorizontal && '500'};
    font-size: ${props => !props.isHorizontal && '14px'};
  }

  h3 {
    margin-top: 5px;
    font-weight: ${props => !props.isHorizontal && '400'};
    width: ${props => !props.isHorizontal && '194px'};
    display: ${props => !props.isHorizontal && '-webkit-box'};
    -webkit-line-clamp: ${props => !props.isHorizontal && '2'};
    -webkit-box-orient: ${props => !props.isHorizontal && 'vertical'};
    overflow: ${props => !props.isHorizontal && 'hidden'};
    text-overflow: ${props => !props.isHorizontal && 'ellipsis'};
  }
`

export const Title = styled.h2`
  color: #2e2e37;
  padding-right: ${props => !props.isHorizontal && '50px'};
`

export const SubTitle = styled.h3`
  color: #8b8c99;
`
